// TODO: this file only used for component test, not be used for production code, need to be updated in the future
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { VIEW_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PreferenceContext } from '@bingads-webui-react/preference-context';
import { staticI18nMock } from '@bingads-webui-test/i18n-mock';
import { PopupContextProvider } from '@bingads-webui-react/popup-manager';

const mockPreferenceService = () => {
  let preference = {
    Data: {},
  };

  return {
    findByNameAtUserLevel: () => preference,
    setAtUserLevel: (data) => {
      preference = data;
    },
  };
};
const preferenceService = mockPreferenceService();

export class RecommendationTabView extends Backbone.View {
  initialize(state) {
    this.state = state;
    this.detailValid = true;
    this.categoryType = state.categoryType || 'All';
    this.lastCategoryType = this.categoryType;
    this.lastRecommendationType = undefined;
    this.lastCampaignId = undefined;
    this.lastAdGroupId = undefined;
    // initialize all legeacy dependencies
    const { legacyRouter } = globalContext.require('component/legacy-router/index');
    const CampaignEditor = globalContext.require('campaignui/feature/crud-campaign/view/create');
    const SearchBidView = globalContext.requireDefault('campaignui/feature/adgroup-create-advanced/view/steps/search-bid');
    const BiddingStrategyView = globalContext.requireDefault('campaignui/feature/bidding-strategy/view/setting');
    const adDisplayUrlService = globalContext.require('campaignui/feature/crud-ad/service/displayUrl');
    const combineText = globalContext.require('campaignui/feature/crud-ad/viewmodel/adsPreview/expandedTextAd');
    const appConfig = globalContext.require('component/config/index');
    const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/competition-tab');
    const instrumentation = globalContext.requireDefault('campaignui/feature/instrumentation/index');
    const jsdata = globalContext.require('component/js-data-campaign/index');
    const CreateKeywordView = globalContext.requireDefault('campaignui/feature/crud-keywords/view/create-inline-recommendation');
    const pageContext = globalContext.require('PageContext');
    const permissions = appConfig.get('Permissions');
    const preferencesService = globalContext.requireDefault('component/preference/service/index');
    const constants = globalContext.require('Constants');
    const dataManager = globalContext.require('campaignui/feature/inline-opportunity/view/data-manager');
    const odata = globalContext.require('component/http/channel/odata');
    const UrlTestTool = globalContext.require('component/upgraded-url/view/urlTestTool');
    const TrackingTemplate = globalContext.require('component/upgraded-url/view/trackingTemplate');
    const UrlEditor = globalContext.require('component/url-input/view/url-input');
    const { testUurl, uurlLevels } = globalContext.require('component/upgraded-url/service/testUurl');
    const appState = globalContext.require('component/state/index');
    const s$i18n = globalContext.require('$/schema-i18n!campaign');
    const schemaCampaignVnext = globalContext.require('component/schema-campaign-vnext/index');
    const validator = globalContext.require('component/ko-validation/index');
    this.legacyDependencies = {
      CampaignEditor,
      SearchBidView,
      BiddingStrategyView,
      adDisplayUrlService,
      appConfig,
      combineText,
      i18n,
      instrumentation,
      jsdata,
      CreateKeywordView,
      legacyRouter,
      pageContext,
      permissions,
      preferencesService,
      constants,
      dataManager,
      odata,
      UrlTestTool,
      TrackingTemplate,
      UrlEditor,
      testUurl,
      uurlLevels,
      appState,
      s$i18n,
      schemaCampaignVnext,
      validator,
    };
  }
  validDetailPage = () => {
    this.detailValid = true;
  };
  render() {
    if (!_.isUndefined(this.el)) {
      import(/* webpackMode: 'eager' */'./recommendation-tab-container').then(({ RecommendationTabContainer }) => {
        ReactDOM.render(
          (
            <PreferenceContext.Provider value={preferenceService}>
              <I18nContext.Provider value={staticI18nMock}>
                <PopupContextProvider permissions={{ IsCentralizedPopupManagementEnabled: true }}>
                  <RecommendationTabContainer
                    {...this.state}
                    validDetailPage={this.validDetailPage}
                    categoryType={this.categoryType}
                    lastCategoryType={this.lastCategoryType}
                    lastRecommendationType={this.lastRecommendationType}
                    lastCampaignId={this.lastCampaignId}
                    lastAdGroupId={this.lastAdGroupId}
                    deps={this.legacyDependencies}
                  />
                </PopupContextProvider>
              </I18nContext.Provider>
            </PreferenceContext.Provider>
          ), this.el
        );
      });
    }

    return this;
  }

  setState(state) {
    const newType = state.recommendationType;
    const oldType = this.state.recommendationType;
    this.lastCampaignId = this.state.scope && this.state.scope.campaignId;
    this.lastAdGroupId = this.state.scope && this.state.scope.adGroupId;
    this.state = state;
    if (!this.detailValid && newType === oldType) {
      this.state.viewType = VIEW_TYPES.SUMMARY;
    }

    if (this.state.viewType === VIEW_TYPES.SUMMARY) {
      this.categoryType = this.state.categoryType;
      this.lastCategoryType = this.categoryType;
    }

    if (this.state.viewType !== VIEW_TYPES.HISTORY) {
      this.lastRecommendationType = newType;
    }
    this.detailValid = false;
    this.render();
  }

  remove() {
    if (!_.isUndefined(this.el)) {
      ReactDOM.unmountComponentAtNode(this.el);
    }
    return super.remove();
  }
}
